import SectionExplore from "../../components/main/SectionExplore";
import SectionBannerStore from "../../components/main/SectionBannerStore";
import SectionTemplate from "../../components/main/SectionTemplate";
import SEOHead from "../../components/common/SEOHead";
import JsonLd from "../../components/common/JsonLd";

const StoreAll: React.FC = () => {
    return (
       <>
         <SEOHead
           title="Giao Diện Website — TrioCore Solutions"
           description="Tổng hợp các mẫu giao diện website chuyên nghiệp, tốc độ tải trang nhanh và tối ưu chuyển đổi từ các chuyên gia TrioCore Solutions."
           path="/store/website"
         />
         <JsonLd
           data={{
             "@context": "https://schema.org",
             "@type": "BreadcrumbList",
             "itemListElement": [
               {
                 "@type": "ListItem",
                 "position": 1,
                 "name": "Trang chủ",
                 "item": "https://triocoresolutions.com.vn/"
               },
               {
                 "@type": "ListItem",
                 "position": 2,
                 "name": "Kho giao diện",
                 "item": "https://triocoresolutions.com.vn/store"
               },
               {
                 "@type": "ListItem",
                 "position": 3,
                 "name": "Giao diện website",
                 "item": "https://triocoresolutions.com.vn/store/website"
               }
             ]
           }}
         />
         <SectionExplore />
         <SectionBannerStore />
         <SectionTemplate />
       </>
    )
}

export default StoreAll;
